import { render, staticRenderFns } from "./BookCategoryTypeSlidebar.vue?vue&type=template&id=1f4e2738"
import script from "./BookCategoryTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./BookCategoryTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports